var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductOrbit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "product-orbit-item-svg",
    width: 739,
    height: 738,
    viewBox: "0 0 739 738",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "product-orbit-item-1",
    opacity: 0.3,
    d: "M0,369a369,369 0 1,0 738,0a369,369 0 1,0 -738,0",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "product-orbit-item-2",
    opacity: 0.3,
    d: "M217,369a152,152 0 1,0 304,0a152,152 0 1,0 -304,0",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "product-orbit-item-ellipse",
    fill: "url(#a)",
    style: {
      mixBlendMode: "plus-lighter"
    },
    d: "M301,374.5a75,67.5 0 1,0 150,0a75,67.5 0 1,0 -150,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6B0FF",
    d: "M327 368.306h17.276v17.347H327v-17.347Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m354.642 375.245-10.366 10.408 17.277 17 18.658-18.735-2.764-27.755h-22.805v19.082Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6B0FF",
    d: "M344.276 385.653h17.277V403h-17.277v-17.347Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M401.98 362.408v15.265l-24.533-24.632L394.724 335l16.93 17.347-9.674 10.061Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6B0FF",
    d: "M394.724 335H412v17.347h-17.276V335Zm-49.757 17.123 16.615-16.682 50.331 50.537-16.614 16.682-50.332-50.537Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_947_32096",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(370.416 369.938) rotate(8.07688) scale(58.1171 69.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.246981,
    stopColor: "#E7D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#440B81",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_947_32096",
    x1: 364.81,
    y1: 435.281,
    x2: 333.241,
    y2: 313.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030979,
    stopColor: "#848AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_947_32096",
    x1: 364.81,
    y1: 435.281,
    x2: 333.241,
    y2: 313.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030979,
    stopColor: "#848AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 371.805,
    x2: 347.195,
    y1: 418.124,
    y2: 324.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#848AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 371.805,
    x2: 347.195,
    y1: 418.124,
    y2: 324.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#848AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(8.072 -2409.516 2852.468) scale(43.3705 51.6686)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#E7D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#440B81",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductOrbit);
export default __webpack_public_path__ + "static/media/ProductOrbit.ef53f48324609fde91e5f26300805737.svg";
export { ForwardRef as ReactComponent };